import { IonChip } from '@ionic/react';
import React, { FC } from 'react';

const cleanPercentage = (percentage: any) => {
  const tooLow = !Number.isFinite(+percentage) || percentage < 0;
  const tooHigh = percentage > 100;
  return tooLow ? 0 : tooHigh ? 100 : +percentage;
};

const Circle : FC<{colour: string, pct?: any}> = ({ colour, pct }) => {
  const r = 70;
  const circ = 2 * Math.PI * r;
  const strokePct = ((100 - pct) * circ) / 100;

  return (
    <circle
      r={r}
      cx={100}
      cy={100}
      fill="transparent"
      stroke={strokePct !== circ ? colour : ""} // remove colour as 0% sets full circumference
      strokeWidth={"1.5rem"}
      strokeDasharray={circ}
      strokeDashoffset={pct ? strokePct : 0}
      strokeLinecap="round"
    ></circle>
  );
};

const Text: FC<{steps: number, goal: number, type: undefined | string}> = ({ steps, goal, type }) => {
  return (
    <>
      <text 
        x="50%"
        y="40%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize={type !== undefined ? "1.5em" : "2.3em"}>
          {type !== undefined ? 
          <>{(steps / 1000).toFixed(1) + ' km'}</>
          : 
          <>{steps.toFixed(0)}</>
          }
      </text>
      <text 
        x="50%"
        y="60%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize={type !== undefined ? "0.8em" : "1em"}>
        /
        {type !== undefined ? 
          <> {(goal / 1000).toFixed(0)  + ' km'}</>
          : 
          <>{goal.toFixed(0)}</>
          }
      </text>
    </>
  );
};

// const Percentage: FC<{percentage: any}> = ({ percentage }) => {
//   return (
//     <text
//       x="50%"
//       y="50%"
//       dominantBaseline="central"
//       textAnchor="middle"
//       fontSize={"1.5em"}
//     >
//       {percentage.toFixed(0)}%
//     </text>
//   );
// };

const Pie: FC<{percentage: any, colour: string, steps: number, goal: number, type: undefined | string}> = ({ percentage, colour, steps, goal, type }) => {
  const pct = cleanPercentage(percentage);
  return (
    <section className="flex flex-col justify-center items-center">
    <svg width={200} height={200}>
      <g transform={`rotate(-90 ${"100 100"})`}>
        <Circle colour="whitesmoke" />
        <Circle colour={colour} pct={pct} />
      </g>
      <Text steps={steps} goal={goal} type={type} />
    </svg>
    <IonChip class="p-2" color="darkblue">{percentage.toFixed()} %</IonChip>
    </section>
  );
};

export default Pie;